var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRacingError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.776,
    height: 170.968
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "racing-error_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_230",
    "data-name": "Rectangle 230",
    fill: "none",
    d: "M0 0h12.385v7.45H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "racing-error_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_577",
    "data-name": "Rectangle 577",
    fill: "none",
    stroke: "#10181c",
    strokeWidth: 1,
    d: "M0 0h10.501v10.5H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "racing-error_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_577-2",
    "data-name": "Rectangle 577",
    fill: "none",
    stroke: "#ff2741",
    strokeWidth: 3,
    d: "M0 0h74v73.993H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "racing-error_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_1245",
    "data-name": "Rectangle 1245",
    fill: "#737c81",
    d: "M0 0h8.624v16.63H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "racing-error_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_1245-2",
    "data-name": "Rectangle 1245",
    fill: "#737c81",
    d: "M0 0h4.791v9.239H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Holder_-_Abandoned_Race",
    "data-name": "Holder - Abandoned Race",
    transform: "translate(-53.417 -315.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_656",
    "data-name": "Group 656",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_654",
    "data-name": "Group 654",
    transform: "translate(14 -10)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "racing-error_svg__Rectangle_282",
    "data-name": "Rectangle 282",
    width: 180,
    height: 90,
    rx: 10,
    transform: "translate(105 345)",
    fill: "#2b3236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_12",
    "data-name": "Line 12",
    fill: "none",
    stroke: "#4f5558",
    strokeWidth: 1,
    d: "M105 405h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_188",
    "data-name": "Line 188",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 367h49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_189",
    "data-name": "Line 189",
    fill: "none",
    stroke: "#4f5558",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 382h113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Semicircle",
    transform: "translate(105 361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_51",
    "data-name": "Rectangle 51",
    d: "M.784 0h11.108A14.108 14.108 0 0126 14.108 14.892 14.892 0 0111.108 29H.784A.784.784 0 010 28.216V.784A.784.784 0 01.784 0z",
    fill: "#10181c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_7",
    "data-name": "Rectangle 7",
    d: "M12 0h48.429A2.571 2.571 0 0163 2.571v18.858A2.571 2.571 0 0160.429 24H12A12 12 0 010 12 12 12 0 0112 0z",
    transform: "translate(225 394)",
    fill: "#ff2741"
  }), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_433",
    "data-name": "Group 433",
    transform: "translate(232.508 402.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_432",
    "data-name": "Group 432",
    clipPath: "url(#racing-error_svg__clip-path)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.292
  }, /*#__PURE__*/React.createElement("rect", {
    id: "racing-error_svg__Rectangle_229",
    "data-name": "Rectangle 229",
    width: 7.029,
    height: 6.092,
    rx: 1.406,
    transform: "translate(.647 .679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_407",
    "data-name": "Path 407",
    d: "M11.544.679L7.676 2.47v2.306l3.87 1.992c.106.082.193.018.193-.141v-5.8c0-.16-.087-.227-.195-.148z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_190",
    "data-name": "Line 190",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    opacity: 0.5,
    d: "M254 406h23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Icon_-_Racing",
    "data-name": "Icon - Racing",
    transform: "translate(108.898 367.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Icons",
    transform: "translate(9.416 3.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Pets-Animals_Pets-Tracking_pet-tracking-cat-search",
    "data-name": "Pets-Animals / Pets-Tracking / pet-tracking-cat-search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Light_22",
    "data-name": "Light 22",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_121",
    "data-name": "Shape 121",
    d: "M330.3 288.352a.167.167 0 01.167.167",
    transform: "translate(-330.129 -288.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_122",
    "data-name": "Shape 122",
    d: "M330.046 288.517a.166.166 0 01.167-.165",
    transform: "translate(-330.046 -288.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_123",
    "data-name": "Shape 123",
    d: "M330.213 288.769a.167.167 0 01-.119-.049.165.165 0 01-.048-.118",
    transform: "translate(-330.046 -288.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_124",
    "data-name": "Shape 124",
    d: "M330.463 288.6a.166.166 0 01-.167.167",
    transform: "translate(-330.129 -288.435)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_6",
    "data-name": "Path 6",
    d: "M6.878 4.848c.028 1.494 2.029 1.86 3.466 1.945a9.576 9.576 0 012.847.7c.621-.535 1.241-1.184.931-1.5a5.638 5.638 0 01-1.917-2.247c-.592-1.183-1-1-1.588-1.638s.432-2.111.432-2.111a4 4 0 00-2.2.677S5.382-.737 1.859 2.815l1.071.409s-1.635.679-2.931 3.772l1.24-.035s-.148 3.243 1.812 4.479c4.783 3.017 7.292 2.449 8.645 3.891 0 0 .6-2.232-2.537-5.509a2.968 2.968 0 01-.807-3.372",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_653",
    "data-name": "Group 653",
    transform: "translate(-16 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "racing-error_svg__Rectangle_282-2",
    "data-name": "Rectangle 282",
    width: 180,
    height: 90,
    rx: 10,
    transform: "translate(105 345)",
    fill: "#2b3236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_12-2",
    "data-name": "Line 12",
    fill: "none",
    stroke: "#4f5558",
    strokeWidth: 1,
    d: "M105 405h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_188-2",
    "data-name": "Line 188",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 367h49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_189-2",
    "data-name": "Line 189",
    fill: "none",
    stroke: "#4f5558",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 382h113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Semicircle-2",
    "data-name": "Semicircle",
    transform: "translate(105 361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_51-2",
    "data-name": "Rectangle 51",
    d: "M.784 0h11.108A14.108 14.108 0 0126 14.108 14.892 14.892 0 0111.108 29H.784A.784.784 0 010 28.216V.784A.784.784 0 01.784 0z",
    fill: "#10181c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Rectangle_7-2",
    "data-name": "Rectangle 7",
    d: "M12 0h45.429A2.571 2.571 0 0160 2.571v18.858A2.571 2.571 0 0157.429 24H12A12 12 0 010 12 12 12 0 0112 0z",
    transform: "translate(228 394)",
    fill: "#ff2741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_190-2",
    "data-name": "Line 190",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    opacity: 0.5,
    d: "M254 406h23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Icon_-_Warning",
    "data-name": "Icon - Warning",
    transform: "translate(235.115 399.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_1511",
    "data-name": "Group 1511",
    clipPath: "url(#racing-error_svg__clip-path-2)",
    fill: "none",
    stroke: "#10181c",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_4298",
    "data-name": "Path 4298",
    d: "M5.25 8.063a.281.281 0 110-.562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_4299",
    "data-name": "Path 4299",
    d: "M5.25 8.063a.281.281 0 100-.562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_552",
    "data-name": "Line 552",
    transform: "translate(5.25 3.563)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 2.25V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_4300",
    "data-name": "Path 4300",
    d: "M9.61 7.824a1.315 1.315 0 01.139.655A1.329 1.329 0 018.42 9.75H2.081a1.328 1.328 0 01-1.132-.631 1.326 1.326 0 01-.058-1.3L4.06 1.486a1.331 1.331 0 012.381 0z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Icon_-_Racing-2",
    "data-name": "Icon - Racing",
    transform: "translate(108.898 367.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Icons-2",
    "data-name": "Icons",
    transform: "translate(9.416 3.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Pets-Animals_Pets-Tracking_pet-tracking-cat-search-2",
    "data-name": "Pets-Animals / Pets-Tracking / pet-tracking-cat-search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_22-2",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Light_22-2",
    "data-name": "Light 22",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_121-2",
    "data-name": "Shape 121",
    d: "M330.3 288.352a.167.167 0 01.167.167",
    transform: "translate(-330.129 -288.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_122-2",
    "data-name": "Shape 122",
    d: "M330.046 288.517a.166.166 0 01.167-.165",
    transform: "translate(-330.046 -288.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_123-2",
    "data-name": "Shape 123",
    d: "M330.213 288.769a.167.167 0 01-.119-.049.165.165 0 01-.048-.118",
    transform: "translate(-330.046 -288.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Shape_124-2",
    "data-name": "Shape 124",
    d: "M330.463 288.6a.166.166 0 01-.167.167",
    transform: "translate(-330.129 -288.435)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Text-2",
    "data-name": "Text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_6-2",
    "data-name": "Path 6",
    d: "M6.878 4.848c.028 1.494 2.029 1.86 3.466 1.945a9.576 9.576 0 012.847.7c.621-.535 1.241-1.184.931-1.5a5.638 5.638 0 01-1.917-2.247c-.592-1.183-1-1-1.588-1.638s.432-2.111.432-2.111a4 4 0 00-2.2.677S5.382-.737 1.859 2.815l1.071.409s-1.635.679-2.931 3.772l1.24-.035s-.148 3.243 1.812 4.479c4.783 3.017 7.292 2.449 8.645 3.891 0 0 .6-2.232-2.537-5.509a2.968 2.968 0 01-.807-3.372",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Icon_-_Warning_Large",
    "data-name": "Icon - Warning Large",
    transform: "translate(53.417 420.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_1511-2",
    "data-name": "Group 1511",
    clipPath: "url(#racing-error_svg__clip-path-3)",
    fill: "none",
    stroke: "#ff2741",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_4298-2",
    "data-name": "Path 4298",
    d: "M5.83 9.223a.861.861 0 010-1.722",
    transform: "translate(31.167 46.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_4299-2",
    "data-name": "Path 4299",
    d: "M5.25 9.223a.861.861 0 000-1.722",
    transform: "translate(31.746 46.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Line_552-2",
    "data-name": "Line 552",
    transform: "translate(37 25.106)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 15.856V0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_4300-2",
    "data-name": "Path 4300",
    d: "M63.188 50.6a9.269 9.269 0 01.98 4.616 9.366 9.366 0 01-9.368 8.957H10.131a9.361 9.361 0 01-7.977-4.447 9.346 9.346 0 01-.409-9.126L24.077 5.937a9.381 9.381 0 0116.779 0z",
    transform: "translate(4.533 4.535)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_657",
    "data-name": "Group 657",
    transform: "translate(281.5 315.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_3942",
    "data-name": "Path 3942",
    d: "M6.226 4.639l2.2-1.345a.207.207 0 00-.108-.383H5.743a1.292 1.292 0 01-1.1-.616L3.293.1a.207.207 0 00-.383.108v2.575a1.291 1.291 0 01-.616 1.1L.1 5.229a.207.207 0 00.108.383h2.574a1.289 1.289 0 011.1.616l1.345 2.2a.207.207 0 00.383-.108V5.745a1.292 1.292 0 01.616-1.1",
    transform: "translate(-14)",
    fill: "#737c81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_3943",
    "data-name": "Path 3943",
    d: "M59.881 19.513l1.6 1.072a.155.155 0 00.227-.194L60.9 18.64a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.075.942l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(-33.384 -9.085)",
    fill: "#737c81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_3944",
    "data-name": "Path 3944",
    d: "M6.109 75.1l1.6 1.072a.155.155 0 00.227-.194l-.808-1.751a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.073.936l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(2.127 -31.659)",
    fill: "#737c81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_2763",
    "data-name": "Group 2763",
    transform: "translate(6.878 6.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_2762",
    "data-name": "Group 2762",
    clipPath: "url(#racing-error_svg__clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_5601",
    "data-name": "Path 5601",
    d: "M8.1 9.869c-1.042 1.481-5.5 6.075-5.689 6.271a1.1 1.1 0 01-1.4.35.827.827 0 01-.361-.746 2.347 2.347 0 01.206-.867l2.173-4.81c-.404-.167-1.105-.446-1.649-.682l-.143-.062C.686 9.089 0 8.8 0 8.043a2.344 2.344 0 01.524-1.282C1.565 5.281 6.025.685 6.215.491A1.1 1.1 0 017.609.14a.827.827 0 01.361.745 2.345 2.345 0 01-.206.867L5.59 6.562c.409.164 1.11.448 1.654.683l.144.061c.55.233 1.236.524 1.236 1.281A2.343 2.343 0 018.1 9.869",
    fill: "#737c81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_2764",
    "data-name": "Group 2764",
    transform: "rotate(-51 -74.5 206.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_2762-2",
    "data-name": "Group 2762",
    clipPath: "url(#racing-error_svg__clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_5601-2",
    "data-name": "Path 5601",
    d: "M4.5 5.483c-.579.823-3.056 3.375-3.161 3.484a.612.612 0 01-.775.195.459.459 0 01-.2-.414 1.3 1.3 0 01.115-.481l1.206-2.674a40.988 40.988 0 01-.919-.379L.687 5.18C.381 5.05 0 4.888 0 4.469a1.3 1.3 0 01.291-.712C.87 2.934 3.347.381 3.453.273a.611.611 0 01.774-.195.459.459 0 01.2.414 1.3 1.3 0 01-.115.482L3.105 3.646c.227.091.617.249.919.38l.08.034c.306.13.687.291.687.711a1.3 1.3 0 01-.291.712",
    fill: "#737c81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_2765",
    "data-name": "Group 2765",
    transform: "translate(-106.338 141.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "racing-error_svg__Group_2762-3",
    "data-name": "Group 2762",
    clipPath: "url(#racing-error_svg__clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "racing-error_svg__Path_5601-3",
    "data-name": "Path 5601",
    d: "M4.5 5.483c-.579.823-3.056 3.375-3.161 3.484a.612.612 0 01-.775.195.459.459 0 01-.2-.414 1.3 1.3 0 01.115-.481l1.206-2.674a40.988 40.988 0 01-.919-.379L.687 5.18C.381 5.05 0 4.888 0 4.469a1.3 1.3 0 01.291-.712C.87 2.934 3.347.381 3.453.273a.611.611 0 01.774-.195.459.459 0 01.2.414 1.3 1.3 0 01-.115.482L3.105 3.646c.227.091.617.249.919.38l.08.034c.306.13.687.291.687.711a1.3 1.3 0 01-.291.712",
    fill: "#737c81"
  })))))));
}
export default __webpack_public_path__ + "static/racing-error.bf66ed4c.svg";
export { SvgRacingError as ReactComponent };